"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpTimeoutError = void 0;
var tslib_1 = require("tslib");
var genericError_js_1 = require("./genericError.js");
var HttpTimeoutError = /** @class */ (function (_super) {
    tslib_1.__extends(HttpTimeoutError, _super);
    function HttpTimeoutError(message, domain) {
        if (domain === void 0) { domain = 'httpApi'; }
        var _this = _super.call(this, { type: 'TimeoutError', domain: domain, message: message }) || this;
        Object.setPrototypeOf(_this, HttpTimeoutError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, HttpTimeoutError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return HttpTimeoutError;
}(genericError_js_1.GenericError));
exports.HttpTimeoutError = HttpTimeoutError;
//# sourceMappingURL=httpTimeoutError.js.map